import React from 'react';
import { ForgotPasswordPage as UiKitForgotPasswordPage } from '@idu-nightlife/ui-kit';
import AppLogo from '../../../../assets/idu-logo-light.svg?react';

const instructions = `Enter your email address and we'll send you instructions to reset the password for
                the iDU account.`;

export const ForgotPasswordPage: React.FC = () => {
  return <UiKitForgotPasswordPage logo={AppLogo} instructions={instructions} hideFooter />;
};

export default ForgotPasswordPage;
